<template>
<RouterLink :to="target">{{ dispValue }}</RouterLink>
</template>

<script>
export default {
  props: {
    item: {},
    column: {},
    value: {},
  },
  computed: {
    dispValue() {
      return this.value;
    },
    typeDesc() {
      return this.stores.auth.typeDesc[this.$route.params.path[0]];
    },
    fieldDesc() {
      if (!this.typeDesc)
        return {};
      var fieldName=this.column.name.split(".")[0];
      return this.typeDesc[fieldName];
    },
    target() {
      var fieldName=this.column.name.split(".")[0];

      var relatedEntity=this.fieldDesc?.target;
      var uuid=this.item[fieldName]?.uuid;

      return {
        name: "page",
        params: {
          path: [relatedEntity, uuid],
        }
      };
    }
  },
}
</script>
